/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * gringotts/v1/services/oauth_app_service.proto
 * OpenAPI spec version: version not set
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import * as axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  DeleteOAuthApp200,
  DeleteOAuthApp2200,
  DeleteOAuthApp2Params,
  DeleteOAuthAppParams,
  GetOAuthAppParams,
  ListOAuthApps2Params,
  ListOAuthAppsParams,
  OAuthAppServiceCreateOAuthAppBodyBody,
  RpcStatus,
  UpdateOAuthAppParams,
  V1ListOAuthAppsResponse,
  V1OAuthApp,
  V1OAuthAppBody,
} from '../../models';

export const listOAuthApps = (
  organizationId: string,
  params?: ListOAuthAppsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListOAuthAppsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/oauthApps`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListOAuthAppsQueryKey = (
  organizationId?: string,
  params?: ListOAuthAppsParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/oauthApps`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListOAuthAppsQueryOptions = <
  TData = Awaited<ReturnType<typeof listOAuthApps>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params?: ListOAuthAppsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listOAuthApps>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOAuthAppsQueryKey(organizationId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOAuthApps>>> = ({
    signal,
  }) => listOAuthApps(organizationId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organizationId,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOAuthApps>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOAuthAppsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOAuthApps>>
>;
export type ListOAuthAppsQueryError = AxiosError<RpcStatus>;

export function useListOAuthApps<
  TData = Awaited<ReturnType<typeof listOAuthApps>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params: undefined | ListOAuthAppsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listOAuthApps>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOAuthApps>>,
          TError,
          Awaited<ReturnType<typeof listOAuthApps>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOAuthApps<
  TData = Awaited<ReturnType<typeof listOAuthApps>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params?: ListOAuthAppsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listOAuthApps>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOAuthApps>>,
          TError,
          Awaited<ReturnType<typeof listOAuthApps>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOAuthApps<
  TData = Awaited<ReturnType<typeof listOAuthApps>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params?: ListOAuthAppsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listOAuthApps>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListOAuthApps<
  TData = Awaited<ReturnType<typeof listOAuthApps>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  params?: ListOAuthAppsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listOAuthApps>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOAuthAppsQueryOptions(
    organizationId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createOAuthApp = (
  organizationId: string,
  oAuthAppServiceCreateOAuthAppBodyBody: OAuthAppServiceCreateOAuthAppBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1OAuthApp>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/oauthApps`,
    oAuthAppServiceCreateOAuthAppBodyBody,
    options,
  );
};

export const getCreateOAuthAppMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOAuthApp>>,
    TError,
    { organizationId: string; data: OAuthAppServiceCreateOAuthAppBodyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOAuthApp>>,
  TError,
  { organizationId: string; data: OAuthAppServiceCreateOAuthAppBodyBody },
  TContext
> => {
  const mutationKey = ['createOAuthApp'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOAuthApp>>,
    { organizationId: string; data: OAuthAppServiceCreateOAuthAppBodyBody }
  > = props => {
    const { organizationId, data } = props ?? {};

    return createOAuthApp(organizationId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOAuthAppMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOAuthApp>>
>;
export type CreateOAuthAppMutationBody = OAuthAppServiceCreateOAuthAppBodyBody;
export type CreateOAuthAppMutationError = AxiosError<RpcStatus>;

export const useCreateOAuthApp = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOAuthApp>>,
      TError,
      { organizationId: string; data: OAuthAppServiceCreateOAuthAppBodyBody },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createOAuthApp>>,
  TError,
  { organizationId: string; data: OAuthAppServiceCreateOAuthAppBodyBody },
  TContext
> => {
  const mutationOptions = getCreateOAuthAppMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getOAuthApp = (
  organizationId: string,
  id: string,
  params?: GetOAuthAppParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1OAuthApp>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/oauthApps/${id}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetOAuthAppQueryKey = (
  organizationId?: string,
  id?: string,
  params?: GetOAuthAppParams,
) => {
  return [
    `/api/v1/organizations/${organizationId}/oauthApps/${id}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOAuthAppQueryOptions = <
  TData = Awaited<ReturnType<typeof getOAuthApp>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  params?: GetOAuthAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOAuthApp>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetOAuthAppQueryKey(organizationId, id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOAuthApp>>> = ({
    signal,
  }) => getOAuthApp(organizationId, id, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && id),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOAuthApp>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOAuthAppQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOAuthApp>>
>;
export type GetOAuthAppQueryError = AxiosError<RpcStatus>;

export function useGetOAuthApp<
  TData = Awaited<ReturnType<typeof getOAuthApp>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  params: undefined | GetOAuthAppParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOAuthApp>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOAuthApp>>,
          TError,
          Awaited<ReturnType<typeof getOAuthApp>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOAuthApp<
  TData = Awaited<ReturnType<typeof getOAuthApp>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  params?: GetOAuthAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOAuthApp>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOAuthApp>>,
          TError,
          Awaited<ReturnType<typeof getOAuthApp>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOAuthApp<
  TData = Awaited<ReturnType<typeof getOAuthApp>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  params?: GetOAuthAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOAuthApp>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOAuthApp<
  TData = Awaited<ReturnType<typeof getOAuthApp>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  id: string,
  params?: GetOAuthAppParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOAuthApp>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOAuthAppQueryOptions(
    organizationId,
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteOAuthApp = (
  organizationId: string,
  id: string,
  params?: DeleteOAuthAppParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteOAuthApp200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organizationId}/oauthApps/${id}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDeleteOAuthAppMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOAuthApp>>,
    TError,
    { organizationId: string; id: string; params?: DeleteOAuthAppParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOAuthApp>>,
  TError,
  { organizationId: string; id: string; params?: DeleteOAuthAppParams },
  TContext
> => {
  const mutationKey = ['deleteOAuthApp'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOAuthApp>>,
    { organizationId: string; id: string; params?: DeleteOAuthAppParams }
  > = props => {
    const { organizationId, id, params } = props ?? {};

    return deleteOAuthApp(organizationId, id, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOAuthAppMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOAuthApp>>
>;

export type DeleteOAuthAppMutationError = AxiosError<RpcStatus>;

export const useDeleteOAuthApp = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOAuthApp>>,
      TError,
      { organizationId: string; id: string; params?: DeleteOAuthAppParams },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOAuthApp>>,
  TError,
  { organizationId: string; id: string; params?: DeleteOAuthAppParams },
  TContext
> => {
  const mutationOptions = getDeleteOAuthAppMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const updateOAuthApp = (
  organizationId: string,
  id: string,
  v1OAuthAppBody: V1OAuthAppBody,
  params?: UpdateOAuthAppParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1OAuthApp>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organizationId}/oauthApps/${id}`,
    v1OAuthAppBody,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getUpdateOAuthAppMutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOAuthApp>>,
    TError,
    {
      organizationId: string;
      id: string;
      data: V1OAuthAppBody;
      params?: UpdateOAuthAppParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOAuthApp>>,
  TError,
  {
    organizationId: string;
    id: string;
    data: V1OAuthAppBody;
    params?: UpdateOAuthAppParams;
  },
  TContext
> => {
  const mutationKey = ['updateOAuthApp'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOAuthApp>>,
    {
      organizationId: string;
      id: string;
      data: V1OAuthAppBody;
      params?: UpdateOAuthAppParams;
    }
  > = props => {
    const { organizationId, id, data, params } = props ?? {};

    return updateOAuthApp(organizationId, id, data, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOAuthAppMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOAuthApp>>
>;
export type UpdateOAuthAppMutationBody = V1OAuthAppBody;
export type UpdateOAuthAppMutationError = AxiosError<RpcStatus>;

export const useUpdateOAuthApp = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOAuthApp>>,
      TError,
      {
        organizationId: string;
        id: string;
        data: V1OAuthAppBody;
        params?: UpdateOAuthAppParams;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateOAuthApp>>,
  TError,
  {
    organizationId: string;
    id: string;
    data: V1OAuthAppBody;
    params?: UpdateOAuthAppParams;
  },
  TContext
> => {
  const mutationOptions = getUpdateOAuthAppMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const listOAuthApps2 = (
  organizationId: string,
  workspaceId: string,
  params?: ListOAuthApps2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1ListOAuthAppsResponse>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/oauthApps`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListOAuthApps2QueryKey = (
  organizationId?: string,
  workspaceId?: string,
  params?: ListOAuthApps2Params,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/oauthApps`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListOAuthApps2QueryOptions = <
  TData = Awaited<ReturnType<typeof listOAuthApps2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: ListOAuthApps2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listOAuthApps2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOAuthApps2QueryKey(organizationId, workspaceId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOAuthApps2>>> = ({
    signal,
  }) =>
    listOAuthApps2(organizationId, workspaceId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOAuthApps2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOAuthApps2QueryResult = NonNullable<
  Awaited<ReturnType<typeof listOAuthApps2>>
>;
export type ListOAuthApps2QueryError = AxiosError<RpcStatus>;

export function useListOAuthApps2<
  TData = Awaited<ReturnType<typeof listOAuthApps2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params: undefined | ListOAuthApps2Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listOAuthApps2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOAuthApps2>>,
          TError,
          Awaited<ReturnType<typeof listOAuthApps2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOAuthApps2<
  TData = Awaited<ReturnType<typeof listOAuthApps2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: ListOAuthApps2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listOAuthApps2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOAuthApps2>>,
          TError,
          Awaited<ReturnType<typeof listOAuthApps2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOAuthApps2<
  TData = Awaited<ReturnType<typeof listOAuthApps2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: ListOAuthApps2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listOAuthApps2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListOAuthApps2<
  TData = Awaited<ReturnType<typeof listOAuthApps2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  params?: ListOAuthApps2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listOAuthApps2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOAuthApps2QueryOptions(
    organizationId,
    workspaceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createOAuthApp2 = (
  organizationId: string,
  workspaceId: string,
  oAuthAppServiceCreateOAuthAppBodyBody: OAuthAppServiceCreateOAuthAppBodyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1OAuthApp>> => {
  return axios.default.post(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/oauthApps`,
    oAuthAppServiceCreateOAuthAppBodyBody,
    options,
  );
};

export const getCreateOAuthApp2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOAuthApp2>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      data: OAuthAppServiceCreateOAuthAppBodyBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOAuthApp2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: OAuthAppServiceCreateOAuthAppBodyBody;
  },
  TContext
> => {
  const mutationKey = ['createOAuthApp2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOAuthApp2>>,
    {
      organizationId: string;
      workspaceId: string;
      data: OAuthAppServiceCreateOAuthAppBodyBody;
    }
  > = props => {
    const { organizationId, workspaceId, data } = props ?? {};

    return createOAuthApp2(organizationId, workspaceId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOAuthApp2MutationResult = NonNullable<
  Awaited<ReturnType<typeof createOAuthApp2>>
>;
export type CreateOAuthApp2MutationBody = OAuthAppServiceCreateOAuthAppBodyBody;
export type CreateOAuthApp2MutationError = AxiosError<RpcStatus>;

export const useCreateOAuthApp2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOAuthApp2>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        data: OAuthAppServiceCreateOAuthAppBodyBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createOAuthApp2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    data: OAuthAppServiceCreateOAuthAppBodyBody;
  },
  TContext
> => {
  const mutationOptions = getCreateOAuthApp2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const getOAuthApp2 = (
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1OAuthApp>> => {
  return axios.default.get(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/oauthApps/${id}`,
    options,
  );
};

export const getGetOAuthApp2QueryKey = (
  organizationId?: string,
  workspaceId?: string,
  id?: string,
) => {
  return [
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/oauthApps/${id}`,
  ] as const;
};

export const getGetOAuthApp2QueryOptions = <
  TData = Awaited<ReturnType<typeof getOAuthApp2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOAuthApp2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetOAuthApp2QueryKey(organizationId, workspaceId, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOAuthApp2>>> = ({
    signal,
  }) =>
    getOAuthApp2(organizationId, workspaceId, id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && workspaceId && id),
    staleTime: 60000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOAuthApp2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOAuthApp2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getOAuthApp2>>
>;
export type GetOAuthApp2QueryError = AxiosError<RpcStatus>;

export function useGetOAuthApp2<
  TData = Awaited<ReturnType<typeof getOAuthApp2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOAuthApp2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOAuthApp2>>,
          TError,
          Awaited<ReturnType<typeof getOAuthApp2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOAuthApp2<
  TData = Awaited<ReturnType<typeof getOAuthApp2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOAuthApp2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOAuthApp2>>,
          TError,
          Awaited<ReturnType<typeof getOAuthApp2>>
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOAuthApp2<
  TData = Awaited<ReturnType<typeof getOAuthApp2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOAuthApp2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOAuthApp2<
  TData = Awaited<ReturnType<typeof getOAuthApp2>>,
  TError = AxiosError<RpcStatus>,
>(
  organizationId: string,
  workspaceId: string,
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOAuthApp2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOAuthApp2QueryOptions(
    organizationId,
    workspaceId,
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const deleteOAuthApp2 = (
  organizationId: string,
  workspaceId: string,
  id: string,
  params?: DeleteOAuthApp2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DeleteOAuthApp2200>> => {
  return axios.default.delete(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/oauthApps/${id}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDeleteOAuthApp2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOAuthApp2>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      id: string;
      params?: DeleteOAuthApp2Params;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOAuthApp2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    id: string;
    params?: DeleteOAuthApp2Params;
  },
  TContext
> => {
  const mutationKey = ['deleteOAuthApp2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOAuthApp2>>,
    {
      organizationId: string;
      workspaceId: string;
      id: string;
      params?: DeleteOAuthApp2Params;
    }
  > = props => {
    const { organizationId, workspaceId, id, params } = props ?? {};

    return deleteOAuthApp2(
      organizationId,
      workspaceId,
      id,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOAuthApp2MutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOAuthApp2>>
>;

export type DeleteOAuthApp2MutationError = AxiosError<RpcStatus>;

export const useDeleteOAuthApp2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOAuthApp2>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        id: string;
        params?: DeleteOAuthApp2Params;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOAuthApp2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    id: string;
    params?: DeleteOAuthApp2Params;
  },
  TContext
> => {
  const mutationOptions = getDeleteOAuthApp2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

export const updateOAuthApp2 = (
  organizationId: string,
  workspaceId: string,
  id: string,
  v1OAuthAppBody: V1OAuthAppBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<V1OAuthApp>> => {
  return axios.default.patch(
    `/api/v1/organizations/${organizationId}/workspaces/${workspaceId}/oauthApps/${id}`,
    v1OAuthAppBody,
    options,
  );
};

export const getUpdateOAuthApp2MutationOptions = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOAuthApp2>>,
    TError,
    {
      organizationId: string;
      workspaceId: string;
      id: string;
      data: V1OAuthAppBody;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOAuthApp2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    id: string;
    data: V1OAuthAppBody;
  },
  TContext
> => {
  const mutationKey = ['updateOAuthApp2'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOAuthApp2>>,
    {
      organizationId: string;
      workspaceId: string;
      id: string;
      data: V1OAuthAppBody;
    }
  > = props => {
    const { organizationId, workspaceId, id, data } = props ?? {};

    return updateOAuthApp2(organizationId, workspaceId, id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOAuthApp2MutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOAuthApp2>>
>;
export type UpdateOAuthApp2MutationBody = V1OAuthAppBody;
export type UpdateOAuthApp2MutationError = AxiosError<RpcStatus>;

export const useUpdateOAuthApp2 = <
  TError = AxiosError<RpcStatus>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOAuthApp2>>,
      TError,
      {
        organizationId: string;
        workspaceId: string;
        id: string;
        data: V1OAuthAppBody;
      },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateOAuthApp2>>,
  TError,
  {
    organizationId: string;
    workspaceId: string;
    id: string;
    data: V1OAuthAppBody;
  },
  TContext
> => {
  const mutationOptions = getUpdateOAuthApp2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
